export default{
    "footer.copyright" : "Propulsée par Spordle ©{year} Spordle Inc. Tous droits réservés.",
    "footer.privacy"   : "Confidentialité",
    "footer.terms"     : "Termes & conditions",
    "footer.sitemap"   : "Plan du site",
    "footer.adminBtn"  : "Administration HCR",
}